export default (ctx, inject) => {
  const _envName = process?.env?.envName
  const gtmKey = 'GTM-P5658NM'
  const enable = _envName === 'staging' || _envName === 'master'

  if (enable) {
    ctx.$gtm.init(gtmKey)

    inject('gtmFillSettingField', (field) => {
      ctx.$gtm.push({ event: `FillField_${field}` })
    })

    inject('gtmButtonClicked', (button) => {
      ctx.$gtm.push({ event: `ButtonClick_${button}` })
    })
  }
}
